var $83d09a059cc4fa14$exports = {};
$83d09a059cc4fa14$exports = {
    "colorSwatchPicker": `Muestras de colores`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Seleccionar un art\xedculo`,
    "tableResizer": `Cambiador de tama\xf1o`
};


export {$83d09a059cc4fa14$exports as default};
//# sourceMappingURL=es-ES.mjs.map
